import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { GET_NOMINATIF, DELETE_NOMINATIF, UPDATE_NOMINATIF, ADD_NEW_NOMINATIF } from "./actionType";

import { getNominatifSuccess, getNominatifFail, deleteNominatifSuccess, deleteNominatifFail, updateNominatifSuccess, updateNominatifFail, addNominatifSuccess, addNominatifFail } from "./action";

//Include Both Helper File with needed carriers
import { approveNominatifApi, getNominatifApi, updateNominatifApi, deleteNominatifApi, addNewNominatifApi } from "../../helpers/backend_helper";

function* getNominatif({ payload: nominatif }) {
  try {
    const response = yield call(getNominatifApi, nominatif);
    yield put(getNominatifSuccess(response));
  } catch (error) {
    yield put(getNominatifFail(error));
  }
}

function* onAddNewNominatif({ payload: nominatif }) {
  try {
    const response = yield call(addNewNominatifApi, nominatif);
    yield put(addNominatifSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    console.error("Error:", error);
    yield put(addNominatifFail(error));
    toast.error(error?.response?.data?.message || "Terjadi kesalahan", {
      autoClose: 3000,
    });
  }
}

function* onUpdateNominatif({ payload: nominatif }) {
  try {
    const response = yield call(updateNominatifApi, nominatif);
    yield put(updateNominatifSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateNominatifFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteNominatif({ payload: nominatif }) {
  try {
    const response = yield call(deleteNominatifApi, nominatif);
    yield put(deleteNominatifSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteNominatifFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

export function* watchGetNominatif() {
  yield takeEvery(GET_NOMINATIF, getNominatif);
}

export function* watchUpdateNominatif() {
  yield takeEvery(UPDATE_NOMINATIF, onUpdateNominatif);
}

export function* watchDeleteNominatif() {
  yield takeEvery(DELETE_NOMINATIF, onDeleteNominatif);
}

export function* watchAddNewNominatif() {
  yield takeEvery(ADD_NEW_NOMINATIF, onAddNewNominatif);
}

function* nominatifSaga() {
  yield all([fork(watchGetNominatif), fork(watchDeleteNominatif), fork(watchUpdateNominatif), fork(watchAddNewNominatif)]);
}

export default nominatifSaga;
